module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_j_piebald.af2553b7.png";